import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../data/axiosInstance/axiosInstance";

const ExternalRedirect = () => {
  const location = useLocation();
  const [error, setError] = useState(null);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [blobUrl, setBlobUrl] = useState(null);
  const [fileName, setFileName] = useState("report.html");

  const params = new URLSearchParams(location.search);
  const url = params.get("url");

  const isTrustedUrl = (url) => {
    try {
      const parsed = new URL(url);
      // Allow only URLs with hostname ending in .cloudfront.net
      return parsed.hostname.endsWith(".cloudfront.net");
    } catch {
      return false;
    }
  };

  useEffect(() => {
    let localBlobUrl = null;
    const fetchHtml = async () => {
      try {
        if (!isTrustedUrl(url)) {
          setError("Not valid URL or Not authorized.");
          setLoading(false);
          return;
        }

        const response = await axiosInstance.get(url, {
          responseType: 'blob',
        });

        const blob = response.data;
        if (blob.type.startsWith("text/html")) {
          localBlobUrl = URL.createObjectURL(blob);
          setIframeUrl(localBlobUrl);
          setBlobUrl(localBlobUrl);

          // Try to extract a filename from the URL or Content-Disposition header
          let name = "report.html";
          const disposition = response.headers['content-disposition'];
          if (disposition && disposition.includes("filename=")) {
            name = disposition.split("filename=")[1].replace(/"/g, "");
          } else {
            try {
              const urlObj = new URL(url);
              const pathParts = urlObj.pathname.split("/");
              if (pathParts.length > 0 && pathParts[pathParts.length - 1].endsWith(".html")) {
                name = pathParts[pathParts.length - 1];
              }
            } catch { }
          }
          setFileName(name);
        } else {
          setError("The file is not a viewable HTML.");
        }
      } catch (error) {
        console.error("Axios error:", error);
        setError("Error fetching the HTML content.");
      } finally {
        setLoading(false);
      }
    };

    fetchHtml();

    // Cleanup blob URLs on unmount
    return () => {
      if (localBlobUrl) URL.revokeObjectURL(localBlobUrl);
    };
    // eslint-disable-next-line
  }, [url]);

  const handleDownload = () => {
    if (blobUrl) {
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (iframeUrl)
    return (
      <div style={{ paddingTop: 24, paddingLeft: 8, paddingRight: 8 }}>
        <button
          onClick={handleDownload}
          className="btn btn-primary mb-3"
          style={{ minWidth: 160, fontWeight: 500, letterSpacing: 0.5 }}
        >
          <i className="bi bi-download me-2" /> Download
        </button>
        <iframe
          src={iframeUrl}
          title="Report"
          style={{ width: "100%", height: "90vh", border: "none" }}
        />
      </div>
    );

  return null;
};

export default ExternalRedirect;